var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticStyle:{"position":"absolute","height":"calc(100% - 55px)","border":"none","top":"54px"},attrs:{"src":'https://employee.simpsonhealthcare.com/login.php?username='+_vm.getEmail,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }